import { GenerationMode, type ChatSessionConfigSnapshot, type PlcBrand, type PlcLanguage } from '../types';
import { sessionSettingsPlcModel } from './sessionTiaTarget';

/**
 * What the composer restores from a conversation's snapshot: the web's own
 * settings, and nothing the server writes into the same snapshot.
 */
export interface ComposerSessionSettings {
  brand: PlcBrand;
  language: PlcLanguage;
  routingMode: GenerationMode;
  softwareVersion: string;
  hardwareSeries: string;
  /** The user's setting, never the model the server resolved (sessionSettingsPlcModel). */
  plcModel: string;
  firmwareVersion: string;
  preferredProvider?: string;
  preferredModel?: string;
}

export function composerSessionSettings(snapshot: ChatSessionConfigSnapshot): ComposerSessionSettings {
  return {
    brand: snapshot.brand,
    language: snapshot.language,
    routingMode: snapshot.routingMode || GenerationMode.FAST,
    softwareVersion: snapshot.softwareVersion || snapshot.targetProfile?.softwareVersion || '',
    hardwareSeries: snapshot.hardwareSeries || snapshot.targetProfile?.hardwareSeries || '',
    plcModel: sessionSettingsPlcModel(snapshot) || '',
    firmwareVersion: snapshot.firmwareVersion || snapshot.targetProfile?.firmwareVersion || '',
    preferredProvider: snapshot.preferredProvider,
    preferredModel: snapshot.preferredModel,
  };
}

/**
 * The composer's settings of a snapshot, serialized: it changes only when what
 * the composer restores does. The server writes the resolved CPU and the TIA
 * project into the same snapshot while a turn runs (TIA 根治 P2, T2b); a
 * restore keyed on the snapshot object put back, at each such write, whatever
 * the user had edited in the composer since the turn began. Empty without a
 * snapshot.
 */
export function composerSessionSettingsKey(snapshot: ChatSessionConfigSnapshot | undefined): string {
  return snapshot ? JSON.stringify(composerSessionSettings(snapshot)) : '';
}
